import React from 'react';
import { useField } from 'react-final-form';

import { MenuItem, TextField } from '@mui/material';

import { EMAIL_TEMPLATES_DEFAULT_FONT_FAMILIES } from '@waypoint/constants';

const fonts = [
  {
    value: 'inherit',
    label: 'Match email settings',
  },
  ...EMAIL_TEMPLATES_DEFAULT_FONT_FAMILIES,
];

type Props = {
  label: string;
  name: string;
};
export default function FontFamilyInput({ label, name }: Props) {
  const {
    input: { value, onChange },
  } = useField(name);

  return (
    <TextField
      select
      variant="standard"
      label={label}
      name={name}
      onChange={(ev) => {
        onChange(ev.target.value);
      }}
      value={value}
    >
      {fonts.map((option) => (
        <MenuItem key={option.value} value={option.value} sx={{ fontFamily: option.value }}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
